<template>
<div>
  <div class="btn-toolbar " role="toolbar" aria-label="Toolbar with button groups">
    <div class="btn-group " role="group" aria-label="First group">
      <button @click="$emit('update',5)" type="button" class="btn btn-success mr-2 text-nowrap">5 %</button>
      <button @click="$emit('update',10)" type="button" class="btn btn-success mr-2 text-nowrap">10 %</button>
      <button @click="$emit('update',15)" type="button" class="btn btn-success mr-2 text-nowrap">15 %</button>
      <button @click="$emit('update',20)" type="button" class="btn btn-success mr-2 text-nowrap">20 %</button>
      <button @click="$emit('update',25)" type="button" class="btn btn-success mr-2 text-nowrap">25 %</button>
      <button @click="$emit('update',30)" type="button" class="btn btn-success mr-2 text-nowrap">30 %</button>
      <button @click="$emit('update',40)" type="button" class="btn btn-success mr-2 text-nowrap">40 %</button>
      <button @click="$emit('update',50)" type="button" class="btn btn-success text-nowrap">50 %</button>
    </div>  
</div>
</div>
</template>
  
<script>
  
  export default {
 

    data() {
      return {
       
  
        
      };
    },
      
   
  }
  </script>
  <style scoped>

  
  </style>
  
  
  